module.exports = __webpack_public_path__ + "img/not-authorized-dark.3119b086.svg";